import config from '@/config';
import { defineStore } from 'pinia';

export const useCustomizerStore = defineStore({
  id: 'customizer',
  state: () => ({
    Sidebar_drawer: config.Sidebar_drawer,
    Customizer_drawer: config.Customizer_drawer,
    mini_sidebar: config.mini_sidebar,
    setHorizontalLayout: config.setHorizontalLayout, // Horizontal layout
    setRTLLayout: config.setRTLLayout, // RTL layout
    actTheme: config.actTheme,
    boxed: config.boxed,
    setBorderCard: config.setBorderCard,
    selectedItem: [],
    selectedMenu: null,
    parentHovered: '',
    inSidebar: false,
    activeChilds: false,
    activeParent: '',
    inActiveChildBody: false,
    childernLocation: {
      y: 0,
      x: 0,
    },
    mobileSidebar: false,
    arrow: false,
    sidebarItem: null,
    fullScreenLoading: false,
  }),

  getters: {},
  actions: {
    SET_SIDEBAR_DRAWER() {
      this.Sidebar_drawer = !this.Sidebar_drawer;
    },
    SET_MINI_SIDEBAR(payload: any) {
      this.mini_sidebar = payload;
    },
    SET_CUSTOMIZER_DRAWER(payload: any) {
      this.Customizer_drawer = payload;
    },
    SET_ORIENTATION(payload: any) {
      this.setRTLLayout = payload;
    },
    SET_LAYOUT(payload: any) {
      this.setHorizontalLayout = payload;
    },
    SET_THEME(payload: any) {
      this.actTheme = payload;
    },
    SET_CARD_BORDER(payload: any) {
      this.setBorderCard = payload;
    },
    IS_DARK() {
      return [
        'DARK_BLUE_THEME',
        'DARK_AQUA_THEME',
        'DARK_ORANGE_THEME',
        'DARK_PURPLE_THEME',
        'DARK_GREEN_THEME',
        'DARK_CYAN_THEME',
      ].includes(this.actTheme);
    },
  },

  persist: {
    storage: persistedState.localStorage,
  },
});
